<!--
 * @Description: hw16v
 * @Date: 2024-01-18 11:09:50
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="container-main">
      <div class="main-top-box">
        <img class="img-top" src="/static/images/industry/hw120v/photo4.png" />
        <div class="img-text-box">
          <img
            class="img-text"
            src="/static/images/industry/hw120v/photo1.png"
          />
          {{$t('industry_hw120v.text1')}}
        </div>
      </div>
      <div>
        <div class="main-text1">{{$t('industry_hw120v.text2')}}</div>
        <div class="main-text2">{{$t('industry_hw120v.text3')}}</div>
        <div class="main-text3">
          {{$t('industry_hw120v.text4')}}
        </div>
        <div class="img-details-box">
          <div class="img-details-content">
            <div class="img-details-left">
              <div class="left-text left-text1" :class="advNum==0?'left-text-hover':''" @mouseover="advNum=0">1</div>
              <div class="left-text left-text2" :class="advNum==1?'left-text-hover':''" @mouseover="advNum=1">2</div>
              <div class="left-text left-text3" :class="advNum==2?'left-text-hover':''" @mouseover="advNum=2">3</div>
              <div class="left-text left-text4" :class="advNum==3?'left-text-hover':''" @mouseover="advNum=3">4</div>
              <div class="left-text left-text5" :class="advNum==4?'left-text-hover':''" @mouseover="advNum=4">5</div>
              <div class="left-text left-text6" :class="advNum==5?'left-text-hover':''" @mouseover="advNum=5">6</div>
              <div class="left-text left-text7" :class="advNum==6?'left-text-hover':''" @mouseover="advNum=6">7</div>
              <div class="left-text left-text8" :class="advNum==7?'left-text-hover':''" @mouseover="advNum=7">8</div>
            </div>
            <div class="img-details-right">
              <div class="right-title">{{$t('industry_hw120v.advantages')[advNum].title}}</div>
              <div class="right-text-box" v-for="(item,index) in ($t('industry_hw120v.advantages')[advNum].childen)" :key="index">
                <img
                  class="img-check"
                  src="/static/images/industry/hw16v/check.png"
                />
                <div>{{ item }}</div>
              </div>
            </div>
          </div>
          <img
            class="img-details"
            src="/static/images/industry/hw120v/photo3.png"
          />
        </div>
      </div>
      <div class="main-bottom-box">
        <img
          class="img-bottom"
          src="/static/images/industry/hw120v/photo2.png"
        />
        <div class="img-text-box2">
          {{$t('industry_hw120v.text5')}}
          <div class="img-text2">
            {{$t('industry_hw120v.text6')}}
          </div>
        </div>
      </div>
      <div class="main-bottom-list">
        <div class="main-text2"> {{$t('industry_hw120v.param.text0')}}</div>
        <div class="list-item" style="margin-top: 30px">
          <div class="list-name">{{$t('industry_hw120v.param.text1')}}</div>
          {{$t('industry_hw120v.param.text1_1')}}
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text2')}}</div>
          8h
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text3')}}</div>
          110—150km/h
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text4')}}</div>
          35kg
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text5')}}</div>
          150kg
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text6')}}</div>
          10m/s
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text7')}}</div>
          6.0*3.03*0.93m
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text8')}}</div>
          6500m
        </div>
        <div class="list-item">
          <div class="list-name">{{$t('industry_hw120v.param.text9')}}</div>
          0.94*1.232.31 With wheels (H)107
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {
      advantages: [
        {
          title: "纯电动 长航时",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时2",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时3",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时4",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时5",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时6",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
      ],
      advNum: 0,
    };
  },
  mounted() {},
  methods: {

  },
};
</script>

<style scoped lang="stylus">
.template-container {
  width: 100%;
  display: flex;

  .container-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-text1 {
      margin-top: 20px;
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      color: #3D3D3D;
    }

    .main-text2 {
      margin-top: 64px;
      font-size: 36px;
      font-weight: 500;
      line-height: 29px;
      color: #1F416B;
    }

    .main-text3 {
      max-width: 1296px;
      margin-top: 48px;
      margin-bottom: 92px;
      font-size: 16px;
      font-weight: 500;
      line-height: 29px;
      color: #A6A6A6;
    }

    .main-top-box {
      background-color: #1F416B;
      width: 100%;
      max-height: 800px;

      .img-top {
        opacity :0.8;
        position: relative;
        object-fit: cover;
        width: 100%;
        height: 800px;
      }

      .img-text-box {
        align-items: flex-start;
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: white;
        position: absolute;
        top: 325px;
        margin-left: 18.2%;
        display: flex;
        flex-direction: column;
        height: 177px;

        .img-text {
          height: 144px;
          object-fit: contrast;
        }
      }
    }

    .img-details-box {
      width: 1296px;
      height: 540px;

      .img-details {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .img-details-content {
        display: flex;
        position: absolute;
        width: 1296px;
        height: 540px;

        .img-details-left {
          font-size: 24px;
          line-height: 39px;
          font-weight: 500;
          width: 936px;
          height: 540px;

          .left-text {
            position: absolute;
            top: 256px;
            left: 525px;
            background: rgba(0, 0, 0, 0.4);
            box-sizing: border-box;
            border: 3px solid #FFFFFF;
            border-radius: 22px;
            width: 44px;
            height: 44px;
            color: #fff;
            text-align: center;
          }
          .left-text-hover{
            color: #007BE7;
            border: 3px solid  #007BE7;
          }

          .left-text1 {
            top: 256px;
            left: 201px;
          }

          .left-text2 {
            top: 297px;
            left: 427px;
          }

          .left-text3 {
            top: 259px;
            left: 521px;
          }

          .left-text4 {
            top: 303px;
            left: 580px;
          }

          .left-text5 {
            top: 237px;
            left: 694px;
          }

          .left-text6 {
            top: 234px;
            left: 793px;
          }
          .left-text7 {
            top: 200px;
            left: 427px;
          }
          .left-text8 {
            top: 190px;
            left: 553px;
          }
        }

        .img-details-right {
          width: 360px;
          height: 540px;
          background-color: rgba(255, 255, 255, 0.8);

          .right-title {
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            color: #3D3D3D;
            margin-top: 57px;
            margin-left: 39px;
          }

          .right-text-box {
            line-height: 29px;
            font-size: 16px;
            font-weight: 500;
            margin: 30px 38px 0px 39px;
            display: flex;
            color: #666;

            .img-check {
              margin-top: 3px;
              margin-right: 11px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .main-bottom-box {
      margin-top: 121px;
      width: 100%;
      max-height: 520px;
      background-color: #1F416B;

      .img-bottom {
        opacity :0.8;
        position: relative;
        object-fit: cover;
        width: 100%;
        height: 520px;
      }

      .img-text-box2 {
        text-align: center;
        color: white;
        position: absolute;
        margin-top: -300px;
        width: 100%;
        font-size: 36px;
        font-weight: 500;

        .img-text2 {
          margin-top: 38px;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .main-bottom-list {
      margin-top: 63px;
      margin-bottom: 82px;

      .list-title {
      }

      .list-item {
        display: flex;
        height: 58px;
        width: 1280px;
        border-bottom: 1px solid #D8D8D8;
        font-size: 18px;
        color: #777;
        line-height: 57px;
      }

      .list-name {
        flex: 1;
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    width: 100%;
    display: flex;

    .container-main {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .main-text1 {
        padding: 0px 5% 0px 5%;
        margin-top: 20px;
        font-size: 12px;
        font-weight: 500;
        line-height: 29px;
        color: #3D3D3D;
        max-width: 90%;
      }

      .main-text2 {
        padding: 0px 5% 0px 5%;
        margin-top: 64px;
        font-size: 36px;
        font-weight: 500;
        line-height: 29px;
        color: #1F416B;
      }

      .main-text3 {
        padding: 0px 5% 0px 5%;
        margin-top: 48px;
        margin-bottom: 92px;
        font-size: 16px;
        font-weight: 500;
        line-height: 29px;
        color: #A6A6A6;
      }

      .main-top-box {
        background-color: #1F416B;
        width: 100%;
        max-height: 400px;

        .img-top {
          position: relative;
          object-fit: cover;
          width: 100%;
          height: 400px;
          opacity :0.8;
        }

        .img-text-box {
          align-items: flex-start;
          font-weight: 800;
          font-size: 24px;
          line-height: 29px;
          color: white;
          position: absolute;
          top: 225px;
          margin-left: 18.2%;
          display: flex;
          flex-direction: column;
          height: 57px;

          .img-text {
            height: 50px;
            object-fit: contrast;
          }
        }
      }

      .img-details-box {
        width: 100%;
        height: 240px;

        .img-details {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .img-details-content {
          display: flex;
          position: absolute;
          width: 100%;
          height: 240px;

          .img-details-left {
            font-size: 12px;
            line-height: 20px;
            font-weight: 500;
            width: 60%;
            height: 240px;

            .left-text {
              position: absolute;
              background: rgba(0, 0, 0, 0.4);
              box-sizing: border-box;
              border: 1px solid #FFFFFF;
              border-radius: 11px;
              width: 22px;
              height: 22px;
              color: #fff;
              text-align: center;
            }
            .left-text-hover{
              color: #007BE7;
              border: 1px solid  #007BE7;
            }

            .left-text1 {
              top: 120px;
              left: 10px;
            }

            .left-text2 {
              top: 140px;
              left: 40px;
            }

            .left-text3 {
              top: 110px;
              left: 70px;
            }

            .left-text4 {
              top: 140px;
              left: 110px;
            }

            .left-text5 {
              top: 130px;
              left: 140px;
            }

            .left-text6 {
              top: 120px;
              left: 170px;
            }
            .left-text7 {
              top: 110px;
              left: 110px;
            }

            .left-text8 {
              top: 90px;
              left: 180px;
            }
          }

          .img-details-right {
            width: 40%;
            height: 240px;
            background-color: rgba(255, 255, 255, 0.8);

            .right-title {
              font-size: 16px;
              font-weight: 900;
              line-height: 20px;
              color: #3D3D3D;
              margin-top: 16px;
              margin-left: 16px;
            }

            .right-text-box {
              line-height: 18px;
              font-size: 12px;
              font-weight: 500;
              margin: 10px 16px 0px 16px;
              display: flex;
              color: #666;

              .img-check {
                margin-top: 3px;
                margin-right: 11px;
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }

      .main-bottom-box {
        margin-top: 121px;
        width: 100%;
        background-color: #1F416B;
        max-height: 220px;

        .img-bottom {
          position: relative;
          object-fit: cover;
          width: 100%;
          opacity :0.8;
          height: 220px;
        }

        .img-text-box2 {
          text-align: center;
          color: white;
          position: absolute;
          margin-top: -150px;
          width: 100%;
          font-size: 24px;
          font-weight: 500;

          .img-text2 {
            margin-top: 38px;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .main-bottom-list {
        margin-top: 63px;
        margin-bottom: 82px;
        width: 90%;
        .list-title {
        }

        .list-item {
          display: flex;
          height: 58px;
          width: 100%;
          border-bottom: 1px solid #D8D8D8;
          font-size: 18px;
          color: #777;
          line-height: 57px;
        }

        .list-name {
          flex: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hw120v.vue